module.exports = __webpack_public_path__ + "img/takeout-message.a54ff65b.png";